import { render, staticRenderFns } from "./CostsSummaryTableEmpty.vue?vue&type=template&id=2cd8ddba&scoped=true&"
import script from "./CostsSummaryTableEmpty.vue?vue&type=script&lang=js&"
export * from "./CostsSummaryTableEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd8ddba",
  null
  
)

export default component.exports